import React, { useEffect, useState, useRef } from 'react';
import './solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "",
    poster: "/videos/bead.jpg",
    heading: "Building Broadband at Home",
    subheading: "Helping communities connect with BEAD & BABA-compliant solutions",
    buttonLink: ""
  }
];



function BEAD() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');


const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  'Cassettes',
  'Fiber Panels',
  'Frames',
];

const facts = [
    { label: "Years of in-house manufacturing", value: 25, prefix: "", suffix: "+", key: "years" },
    { label: "Continents with operations", value: 3, prefix: "", suffix: "", key: "continents" },
    { label: "employees dedicated to your needs", value: 2000, prefix: "~", suffix: "", key: "employees" },
    { label: "on-time delivery", value: 95, prefix: ">", suffix: "%", key: "delivery" },
  ];

  const [counts, setCounts] = useState({
    years: 0,
    continents: 0,
    employees: 0,
    delivery: 0,
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  console.log('isMobile?', isMobile)
  return () => window.removeEventListener("resize", handleResize);
}, []);

  useEffect(() => {
    const animationFrames = {};
    const durations = 600; // in ms

    facts.forEach(fact => {
      const start = performance.now();

      const animate = now => {
        const progress = Math.min((now - start) / durations, 1);
        const currentValue = Math.floor(progress * fact.value);

        setCounts(prev => ({
          ...prev,
          [fact.key]: currentValue,
        }));

        if (progress < 1) {
          animationFrames[fact.key] = requestAnimationFrame(animate);
        }
      };

      animationFrames[fact.key] = requestAnimationFrame(animate);
    });

    return () => {
      Object.values(animationFrames).forEach(cancelAnimationFrame);
    };
  }, []);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);




useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
           disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            {isMobile ? ( <center><img src="/images/beadBadge.png" style={{ height: 100, width: 100 }} /></center> ) : <a href="https://broadbandusa.ntia.gov/technical-assistance/BABA_Compliance_and_Self_Certification" target="_blank"><img src="/images/beadBadge.png" style={{ height: 100, width: 100 }} /></a>}
          </div>
        </div>
      </div>

<svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-alignLeft" style={{ marginTop: 30}} >
        <div className="solutions-section-alignLeft-text-container">
          <h2 className="solutions-section-alignLeft-subheading">Enabling reliable, high-performance fiber networks for rural America</h2>
          <p className="solution-section-alignLeft-description">The best solutions are found right at home. Here, at Go!Foton, we’re designing, developing, and delivering more and more products made in the USA. This helps ensure more businesses can leverage Broadband Equity Access and Deployment (BEAD) program funding, improving access and quality of life for all residents.<br /><br/>As a leading manufacturer of fiber connectivity solutions, we specialize in providing cutting-edge products that are essential for building robust and reliable networks. Our solutions are relied on for Fiber-to-the-Home (FTTH) services in challenging rural environments—areas that are a primary focus of the NTIA’s BEAD program.<br /><br />Broadband expansion in rural communities is critical to the future of America’s digital infrastructure and Go!Foton is here to ensure your projects are not only successful but fully compliant with NTIA’s funding requirements. ​</p>
        </div>
      </div>

      <div className="solutions-section-alignLeft">

        <div className="solutions-section-alignLeft-text-container">
          <h2 className="solutions-section-alignLeft-subheading">BABA compliance assurance</h2>
          <p className="solution-section-alignLeft-description">We are proud to certify that our products and solutions listed here are fully compliant with Buy America provisions, as required for projects funded through the BEAD program. ​</p>
        </div>
          <div className="image-feature-section">
            <div className="feature-card">
              <img src="/images/madeInUSA.jpg" alt="Made in the USA" />
              <h3>Made in the USA</h3>
              <p style={{ fontSize: 20 }}>
                Our products are manufactured with a focus on domestic sourcing and American-made components, ensuring that our solutions meet the highest standards of both quality and regulatory compliance.
              </p>
            </div>

            <div className="feature-card">
              <img src="/images/plantWorkers.jpg" alt="Transparent Manufacturing" />
              <h3>Transparent Manufacturing</h3>
              <p style={{ fontSize: 20}}>
                We maintain full transparency regarding our sourcing and manufacturing practices, ensuring all components of our products meet the Made in America standards, as stipulated by NTIA.
              </p>
            </div>
          </div>
      </div>

      <div className="solutions-section-alignLeft" style={{ marginTop: -30}} >
        <div className="solutions-section-alignLeft-text-container">
          <h2 className="solutions-section-alignLeft-subheading">Limited Applicability Waiver compliance</h2>
            <p className="solution-section-alignLeft-description">
              We understand that certain circumstances may require a waiver under the NTIA Limited Applicability Waiver for BEAD projects. Go!Foton ensures that, where applicable, we strictly follow the NTIA’s guidelines for the Limited Applicability Waiver. This waiver allows for exceptions to the Buy America requirements in cases where:
            </p>

            <ul className="solution-section-alignLeft-description">
              <li>Specific materials are not available domestically.</li>
              <li>Market conditions make full compliance with domestic sourcing impractical.</li>
              <li>Supply chain challenges limit the availability of certain products required for the broadband projects.</li>
            </ul>

            <p className="solution-section-alignLeft-description">
              For each case, we provide detailed documentation and justifications for our use of the NTIA waiver, ensuring that we maintain transparency and meet all compliance standards.
            </p>
        </div>

      </div>

      <div className="image-feature-section" style={{ marginTop: -50 }}> 
            <div style={{ marginRight: isMobile ? 0 : 80}}>
              <p style={{ fontSize: 20, marginBottom: 30, fontWeight: 'bold' }}>Self-Certification of Compliance with<br /> the NTIA BEAD Program:</p>
              <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/other%2FBEAD%20BABA%20Self-Certification%20Letter.pdf?alt=media&token=cc8325b8-f1db-4997-a4cb-59194a089472" className="cta-button">
                Download
              </a>
            </div>

            <div>
              <p style={{ fontSize: 20, marginBottom: 30, fontWeight: 'bold' }}>NTIA Limited Applicability <br />Waiver Documentation:</p>
              <a target='_blank' href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/other%2FBABA%20Waiver.pdf?alt=media&token=cfbc5a92-b3ad-41c6-b7b4-3cc23f0772ee" className="cta-button">
                Download
              </a>
            </div>
          </div>




      <div className="solutions-section-alignLeft" style={{marginTop: 50}}>
        <div className="solutions-section-alignLeft-text-container">
          <h2 className="solutions-section-alignLeft-subheading">Supporting your success is our goal</h2>
          <p className="solution-section-alignLeft-description">Our customers are at the heart of everything we do. Our expert engineering team is available to provide you with the technical support and application guidance you need to successfully deploy fiber networks in challenging rural environments. From design to installation, we’re here to support you every step of the way.<br /><br />Here’s what you can expect.​</p>
        </div>

        <div className="solutions-icon-grid-2">
            <div className="icon-item">
              <img src="/images/icons/lightbulb.png" alt="Icon 1" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10}}>Industry-leading innovation​</p>
              <p>We innovate for your ease of deploying & managing FTTH networks​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/engineering2.png" alt="Icon 2" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Engineering and application support</p>
              <p>Working closely with your team, we recommend the best and most cost-effective solutions for your unique project.​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/customerCare.png" alt="Icon 3" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Outstanding customer care</p>
              <p>Providing personalized, responsive service to ensure your satisfaction</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/rapidResponse.png" alt="Icon 4" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Rapid response times</p>
              <p>A commitment to fast lead times ensures that your projects remain on schedule, even when faced with daunting deadlines​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/quality.png"alt="Icon 5" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Quality & compliance</p>
              <p>Committed to the principles of the NTIA BEAD program, we’re committed to BABA regulations​</p>
            </div>
          </div>
      </div>

      

{!isMobile && (
      <div className="solutions-section-alignLeft table" style={{marginTop: 50}}>
        <div className="solutions-section-alignLeft-text-container" >
          <h2 className="solutions-section-alignLeft-subheading">Statement of compliance & availability</h2>
          <p className="solution-section-alignLeft-description">Go!Foton offers BEAD/BABA compliant configurations of the following products:​</p>
        </div>


      <table class="bead-table">
        <thead>
          <tr>
            <th>Product Category</th>
            <th>Go!Foton Solution</th>
            <th>BEAD/BABA<sup>*</sup><br />Requirements</th>
            <th>BEAD Compliance</th>
            <th>Place of Manufacture</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fiber Cable Assemblies</td>
            <td>
              Patch Cords<br />
              Drop Cables<br />
              OSP Pigtails
            </td>
            <td>Fiber &amp; Cable manufactured in the USA</td>
            <td>Compliant</td>
            <td>Dallas, TX</td>
          </tr>
          <tr>
            <td>Passive Optical Devices &amp; Packaged Modules</td>
            <td>
              PLC Splitters<br />
              Optical TAPs<br />
              WDM Modules<br />
              CEx &amp; WM1
            </td>
            <td>BABA is Waived<br />for BEAD</td>
            <td>Compliant</td>
            <td>Philippines</td>
          </tr>
          <tr>
            <td>OSP Enclosures &amp;<br />Terminals</td>
            <td>
              Multi-Port Midspan Terminal (MMT)<br />
              CHT &amp; M-CHT<br />
              Indoor ST-360<br />
              Compact Terminal<br />
              CORE
            </td>
            <td>
              55% of material content is produced in the USA. Injection
              molding of external housing is done <br/>  in the USA
            </td>
            <td>In Progress<br />(Available starting early Q3 2026)</td>
            <td>Brooksville, FL, Dallas, TX, &amp; <br />Guadalajara, MX</td>
          </tr>
          <tr>
            <td>Other Network Equipment</td>
            <td>
              PEACOC Fiber Panels<br />
              PEACOC EVA Panels<br />
              PEACOC 360 Panels<br />
              Wall Plates
            </td>
            <td>
              De Minimis waiver allowed up to the lesser of 5% of total
              project <br/>cost or $1M
            </td>
            <td>Compliant</td>
            <td>Philippines</td>
          </tr>
        </tbody>
      </table>


      </div>
      )}

<div className="solutions-section-alignLeft" style={{ marginTop: -30, alignItems: 'flex-start'}}>
        <div className="solutions-section-alignLeft-text-container">
       <p className="solution-section-alignLeft-description" style={{ marginBottom: 30}}>Go!Foton offers BEAD/BABA compliant configurations of the following products:​</p>
        <a target='_blank' href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/other%2FBead%20Compliant%20Products.xlsx?alt=media&token=c74b7912-12cf-4d03-8bb6-169306803e1f" className="single-cta-button">
                Download
              </a>
</div></div>

{/* <p>Featured solutions here</p> */}

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default BEAD;
